import { useNavigate } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const sections = [
  { label: "热点快讯", id: "hot" },
  { label: "娱乐动态", id: "ent" },
  { label: "影视资讯", id: "film" },
  { label: "综艺现场", id: "variety" },
  { label: "科技圈", id: "tech" },
  { label: "生活方式", id: "life" },
];

export default function Footer() {
  const navigate = useNavigate();

  const goSection = (id: string) => {
    navigate(`/#${id}`);
  };

  const to = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0 });
  };

  return (
    <footer className="bg-background-900 text-background-100" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <button onClick={() => to("/")} className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl font-black text-background-50">
                海角<span className="text-accent-400">爆</span>
              </span>
            </button>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90">
              专注新鲜快讯与热门事件实时更新的娱乐资讯门户，今日快讯、热门事件进展第一时间同步，吃瓜追更不错过任何节点。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-douban-fill", "ri-bilibili-line", "ri-wechat-line"].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  onClick={(e) => e.preventDefault()}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/10 text-background-100 hover:bg-primary-500 transition-colors"
                  aria-label="社交平台入口"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50 uppercase">栏目导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm">
              {sections.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => goSection(s.id)}
                    className="text-background-200/90 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {s.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50 uppercase">快捷入口</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><button onClick={() => to("/")} className="text-background-200/90 hover:text-accent-400 transition-colors cursor-pointer">返回首页</button></li>
              <li><button onClick={() => to("/about")} className="text-background-200/90 hover:text-accent-400 transition-colors cursor-pointer">关于我们</button></li>
              <li><button onClick={() => to("/faq")} className="text-background-200/90 hover:text-accent-400 transition-colors cursor-pointer">常见问题</button></li>
              <li>
                <a href="mailto:hello@capbao.example" className="inline-flex items-center gap-1.5 text-background-200/90 hover:text-accent-400 transition-colors">
                  <i className="ri-mail-line"></i> {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50 uppercase">关于内容</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85">
              本站内容源于公开信息整理与用户投稿线索，仅供娱乐参考，不代表立场。我们始终坚持以客观、真实、健康为内容准则。
            </p>
            <p className="mt-3 text-xs text-background-200/60">资讯内容每日多次刷新，热搜榜与快讯以实际更新为准。</p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-200/70 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} {siteInfo.brandFull} · 新鲜快讯 · 实时跟进 · 吃瓜追更</p>
          <div className="flex items-center gap-5">
            <button onClick={() => to("/about")} className="hover:text-accent-400 cursor-pointer">免责声明</button>
            <button onClick={() => to("/faq")} className="hover:text-accent-400 cursor-pointer">帮助中心</button>
          </div>
        </div>
      </div>
    </footer>
  );
}